import { toast } from 'react-toastify';
import { put, all, takeLatest } from 'redux-saga/effects';
import * as service from '../../services/inventory.service';
import { fetchRecipesSuccess, getInventoryItemsRequest, getInventoryItemsSuccess, getInventoryOptionsSuccess, setAddInventoryItems, setRemoveInventoryItem, setUpdateRecipe, manageRecipeSuccess, setRemoveRecipe } from '../slice';
import { ADD_INVENTORY_ITEMS_REQUEST, FETCH_MATCHING_INVENTORIES_REQUEST, FETCH_RECIPES_REQUEST, GET_INVENTORY_ITEMS_REQUEST, MANAGE_RECIPE_REQUEST, REMOVE_INVENTORY_ITEMS_REQUEST, REMOVE_RECIPE_REQUEST, UPDATE_INVENTORY_ITEMS_REQUEST } from '../types';

function* addInventoryItemsRequestSaga(action) {
    try {
        const payload = action.payload;
        yield service.addInventoryItems(payload);
        toast.success('Sucessfully updated the inventory');
        yield put(setAddInventoryItems({ show: false }));
        yield put(getInventoryItemsRequest({ hotelId: payload.hotelId }));
    } catch (error) {
        console.error('Failed to fetch inventory items ', error);
        toast.error(`Failed to update inventory items: ${error.message}`);
    }
}

function* getInventoryRequestSaga(action) {
    try {
        const payload = action.payload;
        const res = yield service.fetch(payload);
        yield put(getInventoryItemsSuccess(res));
    } catch (error) {
        console.error('Failed to fetch inventory items ', error);
        toast.error(`Failed to fetch inventory ${error.message}`);
    }
}

function* updateInventoryRequestSaga(action) {
    try {
        const payload = action.payload;
        yield service.updateInventoryItems(payload);
        toast.success('Sucessfully updated the inventory');
        yield put(setAddInventoryItems({ show: false }));
        yield put(getInventoryItemsRequest({ hotelId: payload.hotelId }));
    } catch (error) {
        console.error('Failed to update inventory items ', error);
        toast.error(`Failed to update inventory ${error.message}`);
    }
}

function* removeInventoryRequestSaga(action) {
    try {
        const payload = action.payload;
        yield service.removeInventoryItems(payload);
        toast.success('Sucessfully removed the inventory items');
        yield put(setRemoveInventoryItem({ show: false }));
        yield put(getInventoryItemsRequest({ hotelId: payload.hotelId }));
    } catch (error) {
        console.error('Failed to remove inventory items ', error);
        toast.error(`Failed to remove inventory ${error.message}`);
        yield put(setRemoveInventoryItem({ show: false }));
    }
}

function* fetchRecipesRequestSaga(action) {
    try {
        const payload = action.payload;
        const res = yield service.fetchRecipes(payload);
        yield put(fetchRecipesSuccess(res));
    } catch (error) {
        console.error('Failed to fetch recipes ', error);
        toast.error(`Failed to fetch recipes ${error.message}`);
    }
}

function* fetchMatchingInventoryRequestSaga(action) {
    try {
        const payload = action.payload;
        const res = yield service.fetchMatchingInventories(payload);
        yield put(getInventoryOptionsSuccess(res));
    } catch (error) {
        console.error('Failed to fetch matching inventories', error);
        toast.error(`Failed to fetch matching inventories ${error.message}`);
    }
}

function* manageRecipeRequestSaga(action) {
    try {
        const payload = action.payload;
        const res = yield service.manageRecipes(payload);
        toast.success('Sucessfully saved the recipe');
        yield put(setUpdateRecipe({ show: false }));
        yield put(manageRecipeSuccess(res));
    } catch (error) {
        console.error('Failed to save menu recipe', error);
        toast.error(`Failed to save menu recipe: ${error.message}`);
    }
}

function* removeRecipeRequestSaga(action) {
    try {
        const payload = action.payload;
        yield service.removeRecipe(payload.menuId);
        toast.success('Recipe removed successfully');
        yield put(setRemoveRecipe({ show: false }));
        yield put(manageRecipeSuccess({ menuId: payload.menuId, data: [] }));
    } catch (error) {
        console.error('Failed to remove inventory items ', error);
        toast.error(`Failed to update inventory items: ${error.message}`);
    }
}

export default function* inviteSaga() {
    yield all([
        takeLatest(ADD_INVENTORY_ITEMS_REQUEST, addInventoryItemsRequestSaga),
        takeLatest(GET_INVENTORY_ITEMS_REQUEST, getInventoryRequestSaga),
        takeLatest(UPDATE_INVENTORY_ITEMS_REQUEST, updateInventoryRequestSaga),
        takeLatest(REMOVE_INVENTORY_ITEMS_REQUEST, removeInventoryRequestSaga),
        takeLatest(FETCH_RECIPES_REQUEST, fetchRecipesRequestSaga),
        takeLatest(FETCH_MATCHING_INVENTORIES_REQUEST, fetchMatchingInventoryRequestSaga),
        takeLatest(MANAGE_RECIPE_REQUEST, manageRecipeRequestSaga),
        takeLatest(REMOVE_RECIPE_REQUEST, removeRecipeRequestSaga)
    ]);
}
